"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var endpoints = {
    api: null,
    upload: null,
    chat: null,
};
exports.endpoints = endpoints;
var environment = {
    request: null,
    isNode: false,
    cache: {},
};
exports.environment = environment;
var init = function (domain) {
    if (domain === void 0) { domain = "skiliko.com"; }
    if (typeof domain === "string") {
        endpoints.api = "https://api." + domain;
        endpoints.upload = "https://upload.api." + domain;
        endpoints.chat = "https://chat." + domain;
    }
    else {
        endpoints.api = domain.api;
        endpoints.upload = domain.upload;
        endpoints.chat = domain.chat;
    }
};
var initForBrowser = function (domain) {
    environment.isNode = false;
    environment.request = null;
    environment.cache = window["__SKILIKO_CACHE__"] || {};
    init(domain);
};
exports.initForBrowser = initForBrowser;
var initForNode = function (request, domain) {
    environment.isNode = true;
    environment.request = request;
    environment.cache = {};
    init(domain);
};
exports.initForNode = initForNode;
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/data/constants.js
// module id = 755
// module chunks = 3